import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const LoadingScreen = ({ message }) => {
  const { t } = useTranslation();
  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        width: '100%',
      }}
    >
      <CircularProgress size={60} thickness={4} />
      <Typography 
        variant="h6" 
        sx={{ mt: 3, color: 'text.secondary' }}
      >
        {message || t('common.loading')}
      </Typography>
    </Box>
  );
};

export default LoadingScreen; 